// extracted by mini-css-extract-plugin
module.exports = {"refund-counting-box":"_3v92JF8PJOfEWeb4_e4QOM"};